var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1440,
    width: 3028.2,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1080h2271.15V0H0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v69.135h42.635v-7.424H8.527V38.604h31.834v-7.423H8.527V7.424h34.582V0z",
    transform: "matrix(1.33333 0 0 -1.33333 811.737 440.161)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h10.232l23.971-57.35h.853L59.026 0H69.59v-69.135h-8.385v52.524h-.663L38.324-69.135H30.65L8.717-16.611h-.664v-52.524H0Z",
    transform: "matrix(1.33333 0 0 -1.33333 937.314 347.981)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 1440)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v69.135h23.875c5.527 0 10.051-.974 13.573-2.923 3.521-1.949 6.135-4.578 7.84-7.888 1.705-3.31 2.558-7.006 2.558-11.089 0-4.053-.846-7.749-2.534-11.09-1.69-3.341-4.296-5.993-7.817-7.958-3.522-1.964-8.03-2.946-13.525-2.946H6.917v7.424h16.769c3.79 0 6.837.634 9.143 1.902 2.305 1.268 3.979 3.009 5.022 5.221 1.042 2.211 1.563 4.693 1.563 7.447 0 2.784-.521 5.266-1.563 7.447-1.043 2.18-2.725 3.897-5.046 5.15-2.321 1.253-5.393 1.879-9.214 1.879H8.527V0Z",
    transform: "translate(825.829 749.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0-17.054 31.087h9.664L9.948 0Zm-40.646 0v69.135h23.876c5.526 0 10.05-.921 13.572-2.76 3.521-1.841 6.135-4.362 7.84-7.563C6.348 55.61 7.2 51.967 7.2 47.884c0-4.052-.845-7.655-2.534-10.811-1.69-3.155-4.295-5.622-7.816-7.401-3.522-1.778-8.03-2.668-13.525-2.668h-19.233v7.517h18.949c3.79 0 6.837.541 9.143 1.624 2.304 1.083 3.979 2.622 5.021 4.617 1.042 1.995 1.563 4.369 1.563 7.122 0 2.784-.529 5.212-1.587 7.285-1.058 2.072-2.74 3.681-5.045 4.826-2.305 1.144-5.369 1.716-9.19 1.716h-15.064V0Z",
    transform: "translate(964.258 749.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v69.135h42.635v-7.424H8.527V38.604h31.834v-7.423H8.527V7.424h34.582V0z",
    transform: "translate(1021.87 749.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v69.135h42.635v-7.424H8.527V38.604h31.834v-7.423H8.527V7.424h34.581V0z",
    transform: "translate(1116.053 749.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v-69.135h-8.433l-38.371 54.287h-.758v-54.287h-8.527V0h8.243L-9.19-54.38h.663V0Z",
    transform: "translate(1266.324 819.014)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-16.959v7.424H-.568c5.842 0 10.682 1.097 14.519 3.294 3.837 2.196 6.703 5.336 8.599 9.419 1.894 4.084 2.842 8.94 2.842 14.57 0 5.568-.932 10.37-2.795 14.407-1.864 4.036-4.651 7.145-8.362 9.326-3.711 2.181-8.33 3.271-13.856 3.271h-17.717v7.424H.947c6.854 0 12.72-1.377 17.6-4.129 4.879-2.754 8.613-6.705 11.203-11.856 2.589-5.15 3.885-11.297 3.885-18.443 0-7.208-1.312-13.402-3.933-18.583-2.621-5.182-6.434-9.164-11.44-11.948C13.256 1.392 7.169 0 0 0m-13.264 0h-8.527v69.135h8.527z",
    transform: "translate(1341.369 749.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v69.135h42.635v-7.424H8.527V38.604h31.834v-7.423H8.527V7.424h34.581V0z",
    transform: "translate(1425.509 749.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-16.959v7.424H-.568c5.842 0 10.682 1.097 14.519 3.294 3.837 2.196 6.703 5.336 8.599 9.419 1.894 4.084 2.842 8.94 2.842 14.57 0 5.568-.932 10.37-2.795 14.407-1.864 4.036-4.651 7.145-8.362 9.326-3.711 2.181-8.33 3.271-13.856 3.271h-17.717v7.424H.947c6.854 0 12.72-1.377 17.6-4.129 4.879-2.754 8.613-6.705 11.203-11.856 2.589-5.15 3.885-11.297 3.885-18.443 0-7.208-1.312-13.402-3.933-18.583-2.621-5.182-6.434-9.164-11.44-11.948C13.256 1.392 7.169 0 0 0m-13.264 0h-8.527v69.135h8.527z",
    transform: "translate(1541.483 749.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c4.264 0 8.124 1.059 11.582 3.178 3.459 2.119 6.206 5.236 8.243 9.35s3.056 9.156 3.056 15.126c0 6.001-1.019 11.066-3.056 15.196-2.037 4.129-4.784 7.254-8.243 9.373C8.124 54.341 4.264 55.401 0 55.401c-4.264 0-8.133-1.06-11.606-3.178-3.474-2.119-6.238-5.244-8.29-9.373-2.053-4.13-3.08-9.195-3.08-15.196 0-5.97 1.027-11.012 3.08-15.126 2.052-4.114 4.816-7.231 8.29-9.35C-8.133 1.059-4.264 0 0 0m0-7.795c-6.001 0-11.354 1.438-16.059 4.315-4.707 2.877-8.409 6.967-11.109 12.272-2.7 5.305-4.05 11.592-4.05 18.862 0 7.3 1.35 13.61 4.05 18.931 2.7 5.32 6.402 9.419 11.109 12.296C-11.354 61.758-6.001 63.196 0 63.196c6.032 0 11.385-1.438 16.06-4.315 4.672-2.877 8.352-6.976 11.037-12.296 2.683-5.321 4.026-11.631 4.026-18.931 0-7.27-1.343-13.557-4.026-18.862C24.412 3.487 20.732-.603 16.06-3.48 11.385-6.357 6.032-7.795 0-7.795",
    transform: "translate(1654.095 756.746)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0-17.054 31.087h9.663L9.948 0Zm-40.646 0v69.135h23.876c5.527 0 10.05-.921 13.572-2.76 3.521-1.841 6.135-4.362 7.841-7.563C6.348 55.61 7.2 51.967 7.2 47.884c0-4.052-.845-7.655-2.534-10.811-1.689-3.155-4.295-5.622-7.816-7.401-3.522-1.778-8.03-2.668-13.525-2.668h-19.233v7.517h18.949c3.789 0 6.837.541 9.143 1.624 2.304 1.083 3.979 2.622 5.021 4.617 1.042 1.995 1.564 4.369 1.564 7.122 0 2.784-.53 5.212-1.587 7.285-1.059 2.072-2.741 3.681-5.046 4.826-2.306 1.144-5.369 1.716-9.19 1.716h-15.064V0Z",
    transform: "translate(1776.369 749.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c1.189 0 29.153-.257 29.153-22.684 0-15.644-17.048-22.684-29.153-22.684-22.337 0-42.463 9.481-56.709 24.57C-41.372-7.847-21.597 0 0 0m0-176.102c-48.551 0-88.049 39.499-88.049 88.051 0 5.22.54 10.308 1.419 15.282C-63.04-92.178-32.861-103.852 0-103.852c43.08 0 87.638 30.36 87.638 81.168 0 52.721-45.154 81.169-87.638 81.169-28.653 0-55.324-8.388-77.925-22.659C-76.273 77.431-42.002 110.797 0 110.797c19.437 0 38.061-7.186 52.446-20.233l39.296 43.312C66.578 156.707 33.997 169.282 0 169.282c-75.305 0-136.57-61.264-136.57-136.57 0-17.169 3.324-33.543 9.132-48.693-12.096-21.306-19.096-45.867-19.096-72.07 0-80.803 65.734-146.536 146.534-146.536 54.012 0 103.481 29.566 129.099 77.161L77.6-129.707C62.198-158.325 32.461-176.102 0-176.102",
    transform: "translate(1015.536 505.76)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c0 31.032 10.345 40.805 46.551 40.805v60.916C-43.682 101.721-74.712 72.988-74.712 0v-12.072h-44.828v-59.766h44.828v-231.034H0v231.034h48.277v59.766H0z",
    transform: "translate(349.513 685.964)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M444.173 383.092h74.709v402.293h-74.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c0-131.603-52.876-142.525-72.986-142.525-32.191 0-34.492 33.332-34.492 82.184v162.062h-74.703V-60.341c0-60.925 7.464-129.888 87.924-129.888 38.506 0 72.414 19.545 94.257 62.065v-57.466h74.712v287.351H0z",
    transform: "translate(747.015 568.722)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-38.506 0-73.563-20.111-95.981-63.215v58.616h-74.703V-291.95h74.703v101.721c0 131.612 54.602 142.525 74.71 142.525 32.194 0 36.783-33.331 36.783-82.175V-291.95h74.712v162.071C90.224-68.964 80.459 0 0 0",
    transform: "translate(1342.339 675.042)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c35.057-.575 59.191-14.947 73.56-55.176l61.492 29.882C112.632 33.331 58.042 55.742 0 56.317c-75.287.574-151.148-47.704-151.148-147.125 0-99.421 75.861-147.7 151.148-147.124 58.042.574 112.632 22.984 135.052 81.609L73.56-126.439C59.191-166.67 35.057-181.032 0-181.606c-39.081-.576-76.436 20.685-76.436 90.798S-39.081.574 0 0",
    transform: "translate(1620.5 617.576)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0-62.641 184.481h-79.885l107.469-286.776-14.369-41.38c-10.34-27.009-16.09-28.733-43.105-28.733h-15.512v-65.514h15.512c50.004 0 87.933 20.11 112.641 94.247L143.1 184.481H63.215Z",
    transform: "translate(1898.077 485.962)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3dc4e0405a70229afa4c9f91427747ea.svg";
export { ForwardRef as ReactComponent };